import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TrustPilotWidget from '@/shared/content/blocks/trustpilot/Trustpilot.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrustpilotMiniWidget',
  props: {
    businessUnitId: null,
    hexCode: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TrustPilotWidget, {
    height: "120px",
    width: "200px",
    "hex-code": __props.hexCode,
    "template-id": "53aa8807dec7e10d38f59f32",
    "trustpilot-business-unit-id": __props.businessUnitId
  }, null, 8, ["hex-code", "trustpilot-business-unit-id"]))
}
}

})